<span class="tiebreaker-indicator" *ngIf="visible">
  <mat-icon
    class="tiebreaker-icon"
    [matTooltip]="resolutionSummary"
    (click)="toggle(); $event.stopPropagation()">
    emoji_events
  </mat-icon>

  <span class="tiebreaker-details" *ngIf="expanded">
    {{ resolutionSummary }}
  </span>
</span>
